export default {
  namespaced: true,
  state: {
    all: [],
    loading: false
  },
  getters: {
    all: state => state.all,
    find: state => id => state.all.find(opportunity => opportunity.id == id),
    loading: state => state.loading
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
    setAll(state, opportunities) {
      state.all = opportunities
      state.loading = false
    },
    set(state, opportunity) {
      const find = state.all.find(o => o.id == opportunity.id)
      if (find) state.all.splice(state.all.indexOf(find), 1, opportunity)
      if (!find) state.all.push(opportunity)
    }
  },
  actions: {
    fetchAll({ commit }) {
      commit('startLoading')
      return Vue.$http
        .get('opportunities')
        .then(
          response => commit('setAll', response.data),
          response => commit('stopLoading')
        )
    },
    fetch({ commit }, id) {
      return Vue.$http
        .get(`opportunities/${id}`)
        .then(response => commit('set', response.data))
    }
  }
}
